import { createBrowserRouter } from "react-router";
import { authRoutes } from "@/src/auth/navigations/auth-router";
import { ErrorRouteBoundary } from "@/src/common/components/error-route-boundary";
import { RootLayout } from "@/src/common/layouts/root-layout";
import { RootRedirect } from "@/src/common/navigations/root-redirect";
import NotFoundPage from "@/src/common/pages/not-found-page";
import { oauthRoutes } from "@/src/oauth/navigations/oauth-router";
import { ownerRoutes } from "@/src/owner/navigations/owner-router";
import { publicRoutes } from "@/src/public/navigations/public-router";
import { tenantRoutes } from "@/src/tenant/navigations/tenant-router";

export const rootRouter = createBrowserRouter([
	{
		element: <RootLayout />,
		errorElement: <ErrorRouteBoundary />,
		children: [
			{ path: "/", element: <RootRedirect /> },
			authRoutes,
			oauthRoutes,
			ownerRoutes,
			tenantRoutes,
			...publicRoutes,
			{ path: "*", element: <NotFoundPage /> },
		],
	},
]);
